/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  commentlimits: {
    '& .cardcontrol': {
      minWidth: '110px',
      width: 'auto',
      minHeight: '110px',
      height: '120px',
      flexDirection: 'column',
      alignItems: 'center',
      '& .imgcontent': {
        margin: '8px'
      },
      '& .content': {
        padding: 0,
        width: 'auto'
      },
      '& .triangle': {
        display: 'none'
      }
    },
    '& .previewimg': {
      width: '100%',
      height: pxToEm(320)
    },
    '& .commentlimitspreview': {
      '& h3': {
        fontFamily: '"Source Serif Pro",serif'
      }
    },
    '& .commentwrapper': {
      paddingLeft: pxToEm(48),
      display: 'flex',
      flexDirection: 'column'
    },
    '& .replybutton': {
      padding: pxToEm(8),
      borderRadius: pxToEm(4),
      fontWeight: 600,
      fontSize: pxToEm(16),
      minHeight: '32px',
      maxHeight: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#E7EAF7',
      color: '#000'
    },
    '& .icon-neutral': {
      '& path': {
        fill: '#000'
      }
    },
    '& .loadmorecommentsbutton': {
      background: '#061240',
      color: '#FFF',
      borderRadius: pxToEm(30),
      padding: '16px 32px',
      maxWidth: pxToEm(240),
      marginTop: pxToEm(16),
      boxShadow: '0px 0px 14px 0px #00000033'
    },
    '& .arrowcursor': {
      position: 'relative',
      top: '-20px',
      right: '-200px'
    },
    '& .placeholderwrapper': {
      position: 'relative',
      marginTop: '-16px'
    },
    '& .avatarplaceholder': {
      background: '#DFDFDF',
      borderRadius: pxToEm(40),
      width: pxToEm(36),
      height: pxToEm(36)
    },
    '& .placeholder': {
      background: '#DFDFDF',
      borderRadius: pxToEm(30),
      height: pxToEm(12),
    },
    '& .commentfooter': {
      marginTop: pxToEm(8)
    }
  }
});
